import { render, staticRenderFns } from "./guide-section.vue?vue&type=template&id=2386e7d4"
import script from "./guide-section.js?vue&type=script&lang=js&external"
export * from "./guide-section.js?vue&type=script&lang=js&external"
import style0 from "./guide-section.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports